'use client';
import React, { useEffect } from 'react';
import Script from 'next/script';

interface TargetVideoProps {
  videoId: string;
}

if (typeof window !== 'undefined') {
  window._bp = window._bp || [];
}

export function TargetVideo({ videoId }: TargetVideoProps) {
  const playerRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    window._bp.push({
      div: 'targetPlayer',
      obj: {
        id: '41030',
        width: (playerRef.current?.clientWidth || '480') + '',
        height: (playerRef.current?.clientHeight || '270') + '',
        video: videoId,
      },
    });
    return () => {
      window.$bp?.()?.destroy(false);
    };
  }, [videoId]);

  return (
    <>
      <Script src="https://player.target-video.com/player/build/targetvideo.min.js" />
      <div ref={playerRef} id="targetPlayer" className="w-full h-full" />
    </>
  );
}

export default TargetVideo;
